// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__25lIM","icon":"style_icon__2UskR","avatar":"style_avatar__3e-kN","menuIcon":"style_menuIcon__2mi2u"};